"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var builder_1 = require("./builder");
var httpGet_1 = require("./helpers/httpGet");
var Fuzzer = (function () {
    function Fuzzer(received) {
        var _this = this;
        this.q = {};
        this.ask = function () { return httpGet_1.get(builder_1.buildURL(_this.q)); };
        this.max = function (max) { return _this.k({ max: max }); };
        this.meansLike = function (ml) { return _this.k({ ml: ml }); };
        this.soundsLike = function (sl) { return _this.k({ sl: sl }); };
        this.spelledLike = function (sp) { return _this.k({ sp: sp }); };
        this.startWith = function (s) { return _this.k({ sp: s + "*" }); };
        this.endsWith = function (s) { return _this.k({ sp: "*" + s }); };
        this.nounFromAdjective = function (relJja) { return _this.k({ relJja: relJja }); };
        this.adjectiveFromNoun = function (relJjb) { return _this.k({ relJjb: relJjb }); };
        this.synonym = function (relSyn) { return _this.k({ relSyn: relSyn }); };
        this.triggerWord = function (relTrg) { return _this.k({ relTrg: relTrg }); };
        this.antonym = function (relAnt) { return _this.k({ relAnt: relAnt }); };
        this.moreGeneral = function (relSpc) { return _this.k({ relSpc: relSpc }); };
        this.moreSpecific = function (relGen) { return _this.k({ relGen: relGen }); };
        this.partOf = function (relCom) { return _this.k({ relCom: relCom }); };
        this.comprises = function (relPar) { return _this.k({ relPar: relPar }); };
        this.frequentFollower = function (relBga) { return _this.k({ relBga: relBga }); };
        this.frequentPredecessor = function (relBgb) { return _this.k({ relBgb: relBgb }); };
        this.rhymesWith = function (relRhy) { return _this.k({ relRhy: relRhy }); };
        this.nearRhymesWith = function (relNry) { return _this.k({ relNry: relNry }); };
        this.consonantMatch = function (relCns) { return _this.k({ relCns: relCns }); };
        this.k = function (qq) { return new Fuzzer(__assign({}, _this.q, qq)); };
        this.q = received ? __assign({}, received) : {};
    }
    Fuzzer.init = function () { return new Fuzzer(); };
    return Fuzzer;
}());
module.exports = Fuzzer.init;
exports.default = Fuzzer.init;
//# sourceMappingURL=index.js.map